export const BreadcrumbFields = {
  showHomeIcon: {
    type: "radio",
    label: "Show Home Icon",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
    metadata: {
      source: "manual",
    },
  },
  separator: {
    type: "radio",
    label: "Separator Style",
    options: [
      { label: "Chevron (>)", value: "chevron" },
      { label: "Slash (/)", value: "slash" },
      { label: "Arrow (→)", value: "arrow" },
    ],
    metadata: {
      source: "manual",
    },
  },
  items: {
    type: "array",
    label: "Breadcrumb Items",
    metadata: {
      source: "data",
      description: "Breadcrumb navigation items",
    },
    getItemSummary: (item: { label: string }) => item.label || "New Item",
    arrayFields: {
      label: {
        type: "text",
        label: "Label",
        metadata: {
          description: "Display text for this breadcrumb",
        },
      },
      url: {
        type: "text",
        label: "URL",
        metadata: {
          description:
            "Link URL. The last crumb is the current page, so it never becomes a link — its URL only feeds the breadcrumb schema.",
        },
      },
    },
    defaultItemProps: {
      label: "New Item",
      url: "",
    },
  },
} as const;
